import React from 'react';
import { Route } from 'react-router-dom';
import BorrowingLayout from 'app/components/borrowing/shared/BorrowingLayout';
import AuthenticatedRoute from 'app/routes/AuthenticatedRoute';
import AccountRequiredRoute from 'app/routes/AccountRequiredRoute';
import RecentlyReturnedPageRoute from './RecentlyReturnedPageRoute';

const basePath = '/v2/recentlyreturned';

export default (
  <Route path={basePath}>
    <AuthenticatedRoute>
      <AccountRequiredRoute>
        <BorrowingLayout>
          <RecentlyReturnedPageRoute />
        </BorrowingLayout>
      </AccountRequiredRoute>
    </AuthenticatedRoute>
  </Route>
);
